module.exports = __webpack_public_path__ + "img/mirror_square.8548e2c4.png";